angular.module('am4')
.filter('isPresent', function($translate) {
    return function(input) {
        return input || $translate.instant('NA');
    };
});


// WEBPACK FOOTER //
// ./src/app/filters/isPresent.js